// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FileDropzone_dropzone__0c4Dy {
  width: 100%;
  border: 1.5px dashed rgba(92, 130, 108, 0.38);
  border-radius: 24px;
  min-height: 148px;
  padding: 10px;
  display: grid;
  place-items: center;
  align-content: center;
  background-color: #fff;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}
.FileDropzone_dropzone__0c4Dy:hover {
  border: 1px solid #82b194;
  box-shadow: 0 0 0 4px rgba(130, 177, 148, 0.1411764706);
  box-shadow: 0 0 0 4px rgba(130, 177, 148, 0.1411764706);
  background: rgba(130, 177, 148, 0.1);
  border-color: rgba(92, 130, 108, 0.62);
  transform: translateY(-1px);
}
.FileDropzone_dropzone__icon__pERZO {
  color: #5C826C;
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #eef4f0;
  border-radius: 50%;
}
.FileDropzone_dropzone__text__G1eaq {
  font-weight: 600;
}
.FileDropzone_dropzone__text__G1eaq span {
  text-decoration: none;
  color: #5C826C;
  font-weight: 800;
}
.FileDropzone_dropzone__preview-image__FVPNU {
  max-width: 100%;
  max-height: 120px;
  border-radius: 8px;
  object-fit: contain;
  margin-bottom: 8px;
}
.FileDropzone_dropzone__hint__s3s8b {
  font-size: 0.8rem;
  color: rgba(19, 35, 29, 0.68);
}
.FileDropzone_dropzone--error__0bjZl {
  border-color: #d32f2f;
  background: rgba(211, 47, 47, 0.04);
}
.FileDropzone_dropzone--error__0bjZl:hover {
  border-color: #d32f2f;
  box-shadow: 0 0 0 4px rgba(211, 47, 47, 0.1);
  background: rgba(211, 47, 47, 0.06);
}
.FileDropzone_dropzone__error__LC95p {
  margin-top: 6px;
  font-size: 0.78rem;
  color: #d32f2f;
  font-weight: 500;
  padding-left: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/FileDropzone/FileDropzone.module.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,6CAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,mFAAA;AADF;AAGE;EACE,yBAAA;EACA,uDAAA;EACA,uDAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;AADJ;AAIE;EACE,cAzBS;EA0BT,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAFJ;AAKE;EACE,gBAAA;AAHJ;AAKI;EACE,qBAAA;EACA,cAxCO;EAyCP,gBAAA;AAHN;AAOE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AALJ;AAQE;EACE,iBAAA;EACA,6BAAA;AANJ;AASE;EACE,qBAAA;EACA,mCAAA;AAPJ;AASI;EACE,qBAAA;EACA,4CAAA;EACA,mCAAA;AAPN;AAWE;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AATJ","sourcesContent":["$dark-green: #5C826C;\n\n.dropzone {\n  width: 100%;\n  border: 1.5px dashed rgba(92, 130, 108, .38);\n  border-radius: 24px;\n  min-height: 148px;\n  padding: 10px;\n  display: grid;\n  place-items: center;\n  align-content: center;\n  background-color: #fff;\n  cursor: pointer;\n  transition: background-color .2s ease, border-color .2s ease, transform .2s ease;\n\n  &:hover {\n    border: 1px solid #82b194;\n    box-shadow: 0 0 0 4px #82b19424;\n    box-shadow: 0 0 0 4px rgba(130, 177, 148, 0.1411764706);\n    background: rgba(130, 177, 148, .10);\n    border-color: rgba(92, 130, 108, .62);\n    transform: translateY(-1px);\n  }\n\n  &__icon {\n    color: $dark-green;\n    width: 44px;\n    height: 44px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #eef4f0;\n    border-radius: 50%;\n  }\n\n  &__text {\n    font-weight: 600;\n\n    span {\n      text-decoration: none;\n      color: $dark-green;\n      font-weight: 800;\n    }\n  }\n\n  &__preview-image {\n    max-width: 100%;\n    max-height: 120px;\n    border-radius: 8px;\n    object-fit: contain;\n    margin-bottom: 8px;\n  }\n\n  &__hint {\n    font-size: 0.8rem;\n    color: rgba(19, 35, 29, 0.68);\n  }\n\n  &--error {\n    border-color: #d32f2f;\n    background: rgba(211, 47, 47, 0.04);\n\n    &:hover {\n      border-color: #d32f2f;\n      box-shadow: 0 0 0 4px rgba(211, 47, 47, 0.10);\n      background: rgba(211, 47, 47, 0.06);\n    }\n  }\n\n  &__error {\n    margin-top: 6px;\n    font-size: 0.78rem;\n    color: #d32f2f;\n    font-weight: 500;\n    padding-left: 4px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropzone": `FileDropzone_dropzone__0c4Dy`,
	"dropzone__icon": `FileDropzone_dropzone__icon__pERZO`,
	"dropzone__text": `FileDropzone_dropzone__text__G1eaq`,
	"dropzone__preview-image": `FileDropzone_dropzone__preview-image__FVPNU`,
	"dropzone__hint": `FileDropzone_dropzone__hint__s3s8b`,
	"dropzone--error": `FileDropzone_dropzone--error__0bjZl`,
	"dropzone__error": `FileDropzone_dropzone__error__LC95p`
};
export default ___CSS_LOADER_EXPORT___;
